import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

import { IActionButton } from '../../models/action-button.model';

@Component({
  selector: 'app-address-actions-button',
  templateUrl: './address-actions-button.component.html',
  styleUrls: ['./address-actions-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressActionsButtonComponent {
  @Input() actionList: IActionButton[];
  @Input() tooltipLabel: string;

  @Output() action = new EventEmitter();

  public isActionsOpened: boolean;

  constructor(
    private elementRef : ElementRef,
  ) {}

  public onActionsOpenClick(): void {
    this.isActionsOpened = !this.isActionsOpened;
    if (this.isActionsOpened) {
      this.openActions();
    } else {
      this.closeActions();
    }
  }

  public onActionClick(action: string): void {
    this.closeActions();
    this.action.emit(action);
  }

  @HostListener('window:click', ['$event.target'])
  private onGlobalClick(targetElement): void {
    const addressActionsEl = this.elementRef.nativeElement;
    const isInsideClick = addressActionsEl.contains(targetElement);

    if (!isInsideClick) {
      this.closeActions();
    }
  }

  private openActions(): void {
    this.isActionsOpened = true;
  }

  private closeActions(): void {
    this.isActionsOpened = false;
  }
}
